<main>
    <app-solicitud [numCard]="this.dataRes.card?.numTarjeta" [nuevaSolicitud]="nuevaSolicitud"
        (closeModal)="nuevaSolicitud = $event"></app-solicitud>
    <section class="tarjetas">
        <app-aside (loaded)="loaderOff($event)" (solici)="solicitud($event)"></app-aside>

        <div class="tarjetas__content">

            <div class="tarjetas__content__header">
                <div class="tabs__group">
                    <button routerLinkActive="btn-active" routerLink="centrosAtencion" class="btn">Centros de
                        atención</button>
                    <button routerLinkActive="btn-active" routerLink="puntoVenta" class="btn">Punto de Ventas y
                        Recarga</button>
                    <button routerLinkActive="btn-active" routerLink="direcciones" class="btn">Direcciones</button>
                    <button routerLinkActive="btn-active" routerLink="horarios" class="btn">Horarios</button>
                    <!-- <button routerLinkActive="btn-active" routerLink="maps" class="btn">Mapa</button> -->
                    <!--                <button routerLinkActive="btn-active" routerLink="mandatos" class="btn">Productos</button>
                    <button routerLinkActive="btn-active" routerLink="solicitudes" class="btn">Solicitudes</button> -->
                </div>
            </div>

            <div class="tarjetas__content__content">
                <router-outlet></router-outlet>
            </div>

        </div>
    </section>
</main>